<template>
    <div class="contents">
        <div class="title">
            적립 내역 추가
            <div class="clear"></div>
        </div>
        <div class="c_table_wrap">
            <table style="collapse: collapse">
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <th>증액 / 차감</th>
                    <th>금액</th>
                    <th colspan="2">사유</th>
                </tr>
                <tr>
                    <td class="mpc_td">
                        <div>
                            <el-select class="table_s_select" v-model="addPoint">
                                <el-option value="+" label="(+) 적립금 증액"></el-option>
                                <el-option value="-" label="(-) 적립금 차감"></el-option>
                            </el-select>
                            <div class=""></div>
                        </div>
                    </td>
                    <td class="mpc_td">
                        <div>
                            <el-input v-model="p_point"></el-input>
                            <div class="input_error">{{ validation.firstError('p_point') }}</div>
                        </div>
                    </td>
                    <td colspan="2" class="mpc_td">
                        <div style="display: inline-block" class="mpc_store">
                            <el-input v-model="p_reason"></el-input>
                            <div class="input_error">{{ validation.firstError('p_reason') }}</div>
                        </div>
                        <el-button type="primary" class="search_btn" @click="createPoint()">추가</el-button>
                    </td>
                </tr>
            </table>
        </div>
    </div>

</template>
<script>
import alertMixins from '@/mixins/alertMixins';
import EventBus from "@/mixins/event-bus";
import Vue from "vue";
import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);

export default {
    name: 'PointSaveComponent',
    mixins: [alertMixins],
    components: {},
    props: {
        memberKey: {}
    },
    data() {
        return {
            addPoint: '+',
            p_point: '',
            p_reason: '',
            isRunning: false,
        }
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        _checkValidator() {
            let validatorArr = ['p_point', 'p_reason'];
            return this.$validate(validatorArr).then(success => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                }
                return success;
            });
        },

        _makeParams() {
            let params = {
                code: "CUSTOM",
                mb_no: this.memberKey,
                p_point: this.addPoint === '-' ? `-${this.p_point}` : this.p_point,
                p_reason: this.p_reason,
            }
            return params;
        },

        async createPoint() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
            let validator = await this._checkValidator();
            if (!validator) {
                this.isRunning = false;
                return false;
            }

            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();

            try {
                this.$api.$point.createPoint(params).then(res => res.Data.Result).then(res => {
                    this.isRunning = false;
                    EventBus.$emit('changeLoading', false);
                    if (res.Info.Type === 1) {
                        this.createAlert({
                            title: '',
                            content: '저장 되었습니다.',
                            btnText: '확인',
                            hide: () => {
                                EventBus.$emit('getPointList');
                            }
                        })
                        this.p_point = '';
                        this.p_reason = '';
                    } else {
                        this.errorAlert('저장에 실패했습니다.')
                    }
                })

            } catch (e) {
                console.log(e)
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }

        },
    },
    validators: {
        p_point: function (value) {
            return Validator.value(value)
                .required('포인트를 입력해주세요.')
                .integer('숫자만 입력 가능합니다')
                .greaterThanOrEqualTo(1, '1이상의 숫자만 입력이 가능합니다.')
        },
        p_reason: function (value) {
            return Validator.value(value)
                .required('사유를 입력해주세요.')
        },
    },
}
</script>

<style lang="scss">
.mpc_td {
    border: none !important;
    vertical-align: top;
}

.mpc_store {
    display: inline-block;
    width: calc(100% - 120px);
    margin-right: 10px;
}
</style>
